import { Card, CardHeader } from '@packages/shared/src/ui/Card/Card';
import { defineMessages, useIntl } from 'react-intl';
import { useEffect, useRef } from 'react';
import { usePaybackClient } from './usePaybackClient';

const messages = defineMessages({
  ExternalPaybackCardHeadline: {
    defaultMessage: 'Meine PAYBACK Coupons',
    id: 'Payback.ExternalCard.Headline',
  },
});
const paybackECouponDiv = 'couponnutshell';
export const PaybackCouponCard = () => {
  const { formatMessage } = useIntl();
  const divRef = useRef<HTMLDivElement>(null);
  const { paybackClient } = usePaybackClient();

  useEffect(() => {
    const createModule = async () =>
      paybackClient?.createModule({
        moduleType: 'coupon',
        selector: `#${paybackECouponDiv}`,
        width: divRef.current?.clientWidth ?? 300,
        height: 300,
        contextKey: 'partnerWithoutPaybackContext',
      });
    createModule();
  }, [paybackClient]);

  return (
    <Card>
      <CardHeader hasDivider>
        <h5>{formatMessage(messages.ExternalPaybackCardHeadline)}</h5>
      </CardHeader>
      <div className="p-2">
        <div ref={divRef} title="payback-ecoupons" id={paybackECouponDiv} />
      </div>
    </Card>
  );
};
